import { SiteUtilities } from './utils';

const pricingtable = () => {
  // border right removing when pricing table background color is white.
  if (jQuery('.pricing-page').attr('data-bg-color') === 'color-white') {
    jQuery('.plan-recommended').prev().addClass('br-0');
  }

  /* Custom animation - custom-animation class is added in corresponding pricing widget.html,
     if there any custom animation is used for campaign/special occassion.
     This class will be used to override default pricing animation.
  */
  let gardenJson = '/static-assets/js/animations/garden-animation.json';
  let estateJson = '/static-assets/js/animations/estate-animation.json';
  if (jQuery('.custom-animation').length) {
    gardenJson = '/static-assets/js/animations/custom-garden-animation.json';
    estateJson = '/static-assets/js/animations/custom-estate-animation.json';
  }

  if (jQuery('#animation_garden_container').length > 0) {
    SiteUtilities.onModuleLoad('lib/bodymovin').then(bodymovin => {
      jQuery.getJSON(gardenJson, function (data) {
        bodymovin.loadAnimation({
          wrapper: document.getElementById('animation_garden_container'),
          animType: 'svg',
          loop: true,
          animationData: data
        });
        jQuery('#animation_garden_container .garden-svg').hide();
      });
    });
  }
  if (jQuery('#animation_estate_container').length > 0) {
    SiteUtilities.onModuleLoad('lib/bodymovin').then(bodymovin => {
      jQuery.getJSON(estateJson, function (data) {
        bodymovin.loadAnimation({
          wrapper: document.getElementById('animation_estate_container'),
          animType: 'svg',
          loop: true,
          animationData: data
        });
        jQuery('#animation_estate_container .estate-svg').hide();
      });
    });
  }
  const odoPoller = window.setInterval(function () {
    if (typeof window.Odometer !== 'undefined') {
      clearOdoPoller();
      window.Odometer.init();
    }
  }, 500);

  const clearOdoPoller = function () {
    window.clearInterval(odoPoller);
  };
  function showContactUs (selectedOption) {
    var targetColumn = jQuery(selectedOption).closest('.pricing-table-column');
    targetColumn.find('.button--small').css('display', 'none');
    targetColumn.find('.pricing-contact').css('display', 'inline-block');
    targetColumn.find('.odometer .odometer-inside').addClass('employee-count-plus');
  }
  function hideContactUs (selectedOption) {
    var targetColumn = jQuery(selectedOption).closest('.pricing-table-column');
    targetColumn.find('.button--small').css('display', 'inline-block');
    targetColumn.find('.pricing-contact').css('display', 'none');
    targetColumn.find('.odometer .odometer-inside').removeClass('employee-count-plus');
  }

  jQuery(document).on('click', function (e) {
    jQuery('.fteam-custom-dropdown').removeClass('active');
  });

  jQuery('.fteam-custom-dropdown').on('click', '.plan-input, .icon-arrow-down', function (e) {
    e.stopPropagation();
    if (jQuery(this).closest('.fteam-custom-dropdown').hasClass('active')) {
      jQuery('.fteam-custom-dropdown').removeClass('active');
    } else {
      jQuery('.fteam-custom-dropdown').removeClass('active');
      jQuery(this).closest('.fteam-custom-dropdown').addClass('active');
    }
  }).on('click', '.dropdown-content ul li.option', function (e) {
    e.stopPropagation();
    var employeesDataCount = jQuery(this).attr('data-count');
    var employeesCount = (employeesDataCount === '1000+') ? 1000 : +employeesDataCount;
    jQuery(this).parent().find('li.selected').removeClass('selected');
    jQuery(this).addClass('selected');
    var selectedOptionText = jQuery(this).text();
    jQuery(this).closest('.fteam-custom-dropdown').find('.plan-input').val(selectedOptionText).attr('data-employees-count', (employeesCount) / 50);
    var planPeriod = jQuery('input#pricing_switch').is(':checked') ? 'yearly' : 'monthly';
    var planCost = jQuery(this).closest('.fteam-custom-dropdown').find('.plan-input').attr('data-plan-cost-' + planPeriod);
    var targetNodeId = jQuery(this).parent().attr('data-target-odometer');
    var relatedOdometers = document.querySelector(targetNodeId);
    var employeesCountMultiplier = +jQuery(this).closest('.fteam-custom-dropdown').find('.plan-input').attr('data-employees-count');
    relatedOdometers.innerHTML = employeesCountMultiplier * planCost;
    jQuery(this).closest('.fteam-custom-dropdown').removeClass('active');
    if (employeesDataCount === '1000+') {
      showContactUs(this);
    } else {
      hideContactUs(this);
    }
  });
  jQuery('.pricing-table-mobile-view-options').off('click').on('click', function () {
    jQuery(this).parent().toggleClass('pricing-table-features-opened');
    jQuery(this).parent().find('.tool-tip-button').removeClass('showing');
  });
  jQuery('.omnichannel-header').click(function () {
    jQuery('.omnichannel-wrapper').toggleClass('list-opened');
  });
  // close tooltip when breakpointChanged
  jQuery(window).on('breakpointChanged.tooltip', function () {
    jQuery('.tool-tip-button').removeClass('showing');
  });

  // Change button link in add-ons sections depends on pricing v2 tabs
  const $addOnsFooter = jQuery('.vertical-tab-pricing-wrapper .add-ons-footer');
  if ($addOnsFooter.length) {
    jQuery('.pricing-tab-wrapper .nav-tablist li').on('click', function () {
      const tabId = jQuery(this).find('a').attr('href');
      $addOnsFooter.each(function (index, elem) {
        const $footerButton = jQuery(elem).find('.button');
        const $dynamicLink = jQuery(elem).find('.dynamic-link');
        const helpdeskLink = $dynamicLink.data('helpdesk-link');
        const omnichannelLink = $dynamicLink.data('omnichannel-link');
        if ($footerButton.length && omnichannelLink) {
          if (tabId.startsWith('#support-pricing')) {
            $footerButton.attr('href', helpdeskLink);
          }
          if (tabId.startsWith('#omnichannel')) {
            $footerButton.attr('href', omnichannelLink);
          }
        }
      });
    });
  }
};
export { pricingtable };
